import {isDate} from 'date-fns';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import {isApiDateString, parseDate} from 'shared/web';

import {DateTimePicker} from '../../DateTimePicker/DateTimePicker';
import {useFieldProps} from '../hooks/useFieldProps';
import {DateTimeRendererResponseBody} from '../types/modelSchema';

export function DateTimeRenderer(props: DateTimeRendererResponseBody) {
  const {onChange, value, isRequired, error} = useFieldProps(props);
  const {name, tooltip} = props;

  const date = match(value)
    .when(isDate, always(value))
    .when(isApiDateString, () => parseDate(value))
    .otherwise(always(null));

  return (
    <DateTimePicker
      label={props.label}
      name={name}
      value={date}
      onChange={onChange}
      isRequired={isRequired}
      isRecommended={props.isRecommended}
      errorMessage={error?.message}
      tooltip={tooltip}
      isDisabled={props.isReadOnly}
    />
  );
}
